'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _protocol = require('./protocol');

var _message = require('./message');

var _task = require('./task');

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _engine = require('engine.io-client');

var _engine2 = _interopRequireDefault(_engine);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _network = require('./network');

var _network2 = _interopRequireDefault(_network);

var _constant = require('./constant');

var _constant2 = _interopRequireDefault(_constant);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MSG_SEND_INTERVAL = 200;

var SDK_CODE = {
  ok: 200,
  logining: 301,
  logined: 302,
  no_login: 303,
  no_in_room: 304,
  heartbeat_no_ack: 305,
  login_err: 306,
  interval_err: 300,
  args_err: 307
};

var ResultHandler = function ResultHandler(cb) {
  if (typeof cb === 'undefined') {
    return undefined;
  }
  return function (msg, err) {
    if (typeof err !== 'undefined') {
      cb(err.code, err.msg);
      return;
    }
    if (msg.Cmd === _constant2.default.MSG_RESULT) {
      if (msg.Body.Code === SDK_CODE.ok) {
        cb(SDK_CODE.ok, undefined);
      } else {
        cb(msg.Body.Code, msg.Body.Msg);
      }
      return;
    }
    cb(404, 'cmd not MSG_RESULT');
  };
};

var debug = false;

var logger = function logger() {
  if (debug) {
    var _console;

    (_console = console).log.apply(_console, arguments);
  }
};

var Sync = function Sync() {
  _classCallCheck(this, Sync);

  this.isSyncing = false;
  this.sync_key = 0;
  this.pending_key = 0;
  this.syncTimestamp = 0;
};

var NO_NET = 0;
var CONNECTING = 1;
var CONNECTED = 2;
var LOGINED = 3;

var IMService = function () {
  function IMService(appkey, appsecret) {
    _classCallCheck(this, IMService);

    this.version = 1;
    this.username = '';
    this.debug = true;
    this.sync_key = 0;
    this.pending_key = 0;
    this.isSyncing = false;
    this.seq = 0;
    this.islogin = false;
    this.token = '';
    this.sync = new Sync();
    this.groupSyncKeys = {};
    this.task_queue = new _task.TaskQueue(this.execTask.bind(this), this.defaultHandler.bind(this));
    this.requireReconnect = false;

    this.api_host = '';
    this.login_state = NO_NET;

    this.appkey = appkey;
    this.appsecret = appsecret;
  }

  _createClass(IMService, [{
    key: 'setDebug',
    value: function setDebug(d) {
      debug = d;
    }
  }, {
    key: 'onOpen',
    value: function onOpen(e) {

      this.login_state = CONNECTED;
      if (typeof this.connectListener === 'function') {
        this.connectListener();
      }

      var self = this;

      logger("clear heartbeat_interval");
      clearInterval(self.heartbeat_interval);
      self.heartbeat_interval = setInterval(function () {
        logger("sendHeartBeat");
        self.sendHeartBeat(function (code, msg) {
          if (code != SDK_CODE.ok) {

            logger("disconnect");
            self.task_queue.clear();
            self.socket.close();
          }
        });
      }, 10000);

      this.sendAccess(this.username, this.pwd, this.platformId, function (code, msg) {
        if (code === SDK_CODE.ok) {
          self.login_state = LOGINED;
          self.requireReconnect = true;
        } else {
          self.disconnect();
          self.login_state = NO_NET;
        }
        if (typeof self.loginCallback === 'function') {
          self.loginCallback(code, msg);
        }
      });
    }
  }, {
    key: 'onMessage',
    value: function onMessage(data) {
      var msg = (0, _protocol.fromData)(data);
      this.handleMsg(msg);
    }
  }, {
    key: 'onClose',
    value: function onClose(e) {
      logger("onclose");
      this.handleClose();
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      var self = this;

      self.login_state = NO_NET;
      if (typeof this.disconnectListener === 'function') {
        this.disconnectListener();
      }

      clearInterval(self.heartbeat_interval);

      clearInterval(self.room_interval);

      self.connectFailCount = self.connectFailCount || 0;
      if (self.connectFailCount > 100) {
        self.requireReconnect = false;
      }
      self.connectFailCount++;

      self.task_queue.clear();

      if (self.requireReconnect) {

        setTimeout(function () {
          if (typeof self.tryconnectListener === 'function') {
            self.tryconnectListener();
          }
          self.connect(self.ws_url);
          self.login_state = CONNECTING;
        }, 1000);
      } else {
        if (typeof self.netFailListener === 'function') {
          self.netFailListener();
        }
      }
    }
  }, {
    key: 'onError',
    value: function onError(e) {
      logger("onError,e=", e);
      this.handleClose();
    }
  }, {
    key: 'connect',
    value: function connect(ws_url) {

      var self = this;
      var socket = void 0;
      var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
      if (BrowserWebSocket) {
        socket = (0, _engine2.default)(ws_url, { transports: ["websocket"] });
      } else {
        socket = (0, _engine2.default)(ws_url, { transports: ["polling"] });
      }

      socket.on('open', function (e) {
        self.onOpen(e);

        socket.on('message', function (data) {
          self.onMessage(data);
        });

        socket.on('close', function (e) {
          self.onClose(e);
        });
      });

      socket.on('error', function (err) {
        self.onError(err);
      });
      self.socket = socket;
    }

    /************************** api start **************************/

    /**
     * 初始化 服务器地址
     * @param ws_url
     * @param api_host
     */

  }, {
    key: 'init',
    value: function init(ws_url, api_host) {
      this.ws_url = ws_url;
      this.api_host = api_host;
    }

    /**
     * 登录
     * @param username
     * @param pwd
     * @param platformId
     * @param cb
     */

  }, {
    key: 'login',
    value: function login(username, pwd, platformId) {

      var self = this;

      if (self.login_state === CONNECTED) {
        if (typeof self.loginCallback === 'function') {
          self.loginCallback(SDK_CODE.logining, "正在登录中");
        }
        return;
      }
      if (self.login_state === LOGINED) {
        if (typeof self.loginCallback === 'function') {
          self.loginCallback(SDK_CODE.logined, "已经登录");
        }
        return;
      }

      self.username = username;
      self.pwd = pwd;
      self.platformId = platformId;
      self.connectFailCount = 0;

      self.connect(self.ws_url);
    }
  }, {
    key: 'setLoginStatusListener',
    value: function setLoginStatusListener(cb) {
      if (typeof cb === 'function') {
        this.loginCallback = cb;
      }
    }

    /**
     * 连接成功
     * @param cb
     */

  }, {
    key: 'setConnectListener',
    value: function setConnectListener(cb) {
      if (typeof cb === 'function') {
        this.connectListener = cb;
      }
    }

    /**
     * 连接失败
     * @param cb
     */

  }, {
    key: 'setDisconnectListener',
    value: function setDisconnectListener(cb) {
      if (typeof cb === 'function') {
        this.disconnectListener = cb;
      }
    }

    /**
     * 尝试重连
     * @param cb
     */

  }, {
    key: 'setTryconnectListener',
    value: function setTryconnectListener(cb) {
      if (typeof cb === 'function') {
        this.tryconnectListener = cb;
      }
    }

    /**
     * 网络错误
     * @param cb
     */

  }, {
    key: 'setNetFailListener',
    value: function setNetFailListener(cb) {
      if (typeof cb === 'function') {
        this.netFailListener = cb;
      }
    }

    /**
     * 进入某个聊天室(房间)
     * @param roomId
     * @param cb
     */

  }, {
    key: 'enterRoom',
    value: function enterRoom(roomId, cb) {
      var self = this;

      if (self.login_state !== LOGINED) {
        if (typeof cb === 'function') {
          cb(SDK_CODE.no_login, '未登录');
        }
        return;
      }

      if (typeof roomId !== 'string' || roomId === '') {
        if (typeof cb === 'function') {
          cb(SDK_CODE.args_err, 'roomId须为非空字符串');
        }
        return;
      }

      var enter_room = new _message.Room(roomId);
      var msg = new _message.Message(_constant2.default.MSG_ENTER_ROOM, 0, this.version, enter_room);

      this.enqueueTask(new _task.Task(msg, ResultHandler(function (code, msg) {
        if (code === SDK_CODE.ok) {
          self.roomId = roomId;

          self.getRoomState(function (data, err) {
            if (typeof err === 'undefined') {
              self.updateRoomState(data);
            }
          });
        }
        if (typeof cb === 'function') {
          cb(code, msg);
        }
      })));
    }

    /**
     * 离开当前聊天室(房间)
     * @param cb
     */

  }, {
    key: 'leaveRoom',
    value: function leaveRoom(cb) {

      if (this.login_state !== LOGINED) {
        if (typeof cb === 'function') {
          cb(SDK_CODE.no_login, '未登录');
        }
        return;
      }

      if (typeof this.roomId === 'undefined' || this.roomId === 0) {
        logger('不在聊天室内');
        return;
      }

      var leave_room = new _message.Room(this.roomId);

      var msg = new _message.Message(_constant2.default.MSG_LEAVE_ROOM, 0, this.version, leave_room);
      var self = this;
      this.enqueueTask(new _task.Task(msg, ResultHandler(function (code, msg) {
        if (code === SDK_CODE.ok) {
          clearInterval(self.room_interval);
        }
        if (typeof cb === 'function') {

          cb(code, msg);
        }
      })));
    }

    /**
     * 设置私聊消息回调
     * @param listener
     */

  }, {
    key: 'setPeerListener',
    value: function setPeerListener(listener) {
      if (typeof listener === 'function') {
        this.peerListener = listener;
      }
    }

    /**
     * 设置群聊消息回调
     * @param listener
     */

  }, {
    key: 'setGroupListener',
    value: function setGroupListener(listener) {
      if (typeof listener === 'function') {
        this.groupListener = listener;
      }
    }

    /**
     * 设置聊天室消息回调
     * @param listener
     */

  }, {
    key: 'setRoomListener',
    value: function setRoomListener(listener) {
      if (typeof listener === 'function') {
        this.roomListener = listener;
      }
    }

    /**
     * 设置房间状态回调
     * @param listener
     */

  }, {
    key: 'setRoomStateListener',
    value: function setRoomStateListener(listener) {
      if (typeof listener === 'function') {
        this.roomStateListener = listener;
      }
    }

    /**
     * 设置自定义系统消息回调
     * @param listener
     */

  }, {
    key: 'setCustomSysListener',
    value: function setCustomSysListener(listener) {
      if (typeof listener === 'function') {
        this.customSysListener = listener;
      }
    }

    /**
     * 设置透传消息回调
     * @param listener
     */

  }, {
    key: 'setTransListener',
    value: function setTransListener(listener) {
      if (typeof listener === 'function') {
        this.transListener = listener;
      }
    }

    /**
     * 房间成员加入回调
     * @param listener
     */

  }, {
    key: 'setRoomMemberJoinListener',
    value: function setRoomMemberJoinListener(listener) {
      if (typeof listener === 'function') {
        this.roomMemberJoinListener = listener;
      }
    }

    /**
     * 房间成员离开回调
     * @param listener
     */

  }, {
    key: 'setRoomMemberLeftListener',
    value: function setRoomMemberLeftListener(listener) {
      if (typeof listener === 'function') {
        this.roomMemberLeftListener = listener;
      }
    }

    /**
     * 另一客户端登录
     * @param listener
     */

  }, {
    key: 'setAnotherLoginListener',
    value: function setAnotherLoginListener(listener) {
      if (typeof listener === 'function') {
        this.anotherLoginListener = listener;
      }
    }

    /**
     * 透传消息
     * @param to string类型(username|groupId|roomId)
     * @param content
     * @param type 1: to为username ; 2: to为groupId ; 3: to 为roomId
     * @param cb
     */

  }, {
    key: 'sendTransMsg',
    value: function sendTransMsg(to, content, type, cb) {
      if (this.login_state !== LOGINED) {
        if (typeof cb === 'function') {
          cb(SDK_CODE.no_login, '未登录');
        }
        return;
      }
      var transMsg = new _message.TransMessage(this.username, to, content, type);
      var msg = new _message.Message(_constant2.default.MSG_TRANSMISSION, 0, this.version, transMsg);

      this.enqueueTask(new _task.Task(msg, ResultHandler(function (code, msg) {
        if (typeof cb === 'function') {
          cb(code, msg);
        }
      })));
    }

    /**
     * 私聊
     * @param to
     * @param content
     * @param cb
     */

  }, {
    key: 'sendPeerMsg',
    value: function sendPeerMsg(to, content, cb) {
      if (this.login_state !== LOGINED) {
        if (typeof cb === 'function') {
          cb(SDK_CODE.no_login, '未登录');
        }
        return;
      }
      var IMMsg = new _message.IMMessage(this.username, to, content);
      var msg = new _message.Message(_constant2.default.MSG_IM, 0, this.version, IMMsg);

      this.enqueueTask(new _task.Task(msg, ResultHandler(function (code, msg) {
        if (typeof cb === 'function') {
          cb(code, msg);
        }
      })));
    }

    /**
     * 群聊
     * @param to
     * @param content
     * @param cb
     */

  }, {
    key: 'sendGroupMsg',
    value: function sendGroupMsg(to, content, cb) {
      if (this.login_state !== LOGINED) {
        if (typeof cb === 'function') {
          cb(SDK_CODE.no_login, '未登录');
        }
        return;
      }
      var IMMsg = new _message.IMMessage(this.username, to.toString(), content);
      var msg = new _message.Message(_constant2.default.MSG_GROUP_IM, 0, this.version, IMMsg);

      this.enqueueTask(new _task.Task(msg, ResultHandler(function (code, msg) {
        if (typeof cb === 'function') {
          cb(code, msg);
        }
      })));
    }

    /**
     * 聊天室消息
     * @param content
     * @param cb
     */

  }, {
    key: 'sendRoomMsg',
    value: function sendRoomMsg(content, cb) {
      if (this.login_state !== LOGINED) {
        if (typeof cb === 'function') {
          cb(SDK_CODE.no_login, '未登录');
        }
        return;
      }
      if (typeof this.roomId == 'undefined' || this.roomId === 0) {
        logger('不在聊天室内');
        if (typeof cb === 'function') {
          cb(SDK_CODE.no_in_room, '不在聊天室内');
        }
        return;
      }

      var roomMsg = new _message.RoomMessage(this.username, this.roomId, content);
      var msg = new _message.Message(_constant2.default.MSG_ROOM_IM, 0, this.version, roomMsg);

      this.enqueueTask(new _task.Task(msg, ResultHandler(function (code, msg) {
        if (typeof cb === 'function') {
          cb(code, msg);
        }
      })));
    }

    /**
     * 修改聊天室(房间)状态值
     * @param type  string('set'|'incr')
     * @param key   string
     * @param value string
     * @param cb
     */

  }, {
    key: 'sendRoomStateModify',
    value: function sendRoomStateModify(type, key, value, cb) {
      if (this.login_state !== LOGINED) {
        if (typeof cb === 'function') {
          cb(SDK_CODE.no_login, '未登录');
        }
        return;
      }
      var modifyMsg = new _message.ModifyMessage(this.username, this.roomId, type, key, value);
      var msg = new _message.Message(_constant2.default.MSG_ROOM_SET_STATE, 0, this.version, modifyMsg);

      this.enqueueTask(new _task.Task(msg, ResultHandler(function (code, msg) {
        if (typeof cb === 'function') {
          cb(code, msg);
        }
      })));
    }

    /**
     * 主动断开连接
     */

  }, {
    key: 'disconnect',
    value: function disconnect() {
      this.task_queue.clear();
      this.requireReconnect = false;
      this.socket.close();
    }

    /**
     * 检测是否登录
     * @returns {boolean}
     */

  }, {
    key: 'isLogin',
    value: function isLogin() {
      return this.login_state === LOGINED;
    }

    /************************** api end **************************/

  }, {
    key: 'send',
    value: function send(msg) {
      this.sendMsg(msg);
    }
  }, {
    key: 'enqueueTask',
    value: function enqueueTask(task) {
      this.task_queue.push(task);
    }
  }, {
    key: 'sendHeartBeat',
    value: function sendHeartBeat(cb) {
      var msg = new _message.Message(_constant2.default.MSG_HEARTBEAT, 0, this.version, new _message.HeartBeatMessage());
      var task = new _task.Task(msg, function (msg, err) {
        if (typeof err !== 'undefined') {
          cb(SDK_CODE.heartbeat_no_ack, "heartbeat no ack");
          return;
        }
        cb(SDK_CODE.ok, "heartbeat ack");
      });
      this.enqueueTask(task);
    }
  }, {
    key: 'sendAccess',
    value: function sendAccess(username, token, platformId, cb) {
      var self = this;
      var tokenMsg = new _message.AuthTokenMessage(this.appkey, username, token, "", platformId);

      var msg = new _message.Message(_constant2.default.MSG_AUTH_TOKEN, 0, this.version, tokenMsg);

      var task = new _task.Task(msg, function (msg, err) {
        if (typeof err !== 'undefined') {
          if (typeof cb === 'function') {
            cb(err.code, err.msg);
          }
          logger("task err:", err);
          return;
        }
        logger("sendAccess", msg);
        if (msg.Cmd === _constant2.default.MSG_AUTH_STATUS) {
          if (msg.Body.Status === 1) {
            self.token = token;
            self.platformId = platformId;
            self.islogin = true;
            self.sendSync(this.sync_key);
            self.syncGroup();

            if (typeof cb === 'function') {
              cb(SDK_CODE.ok, '验证成功');
            }
            return;
          }
        }
        if (typeof cb === 'function') {
          cb(SDK_CODE.login_err, '验证错误');
        }
      });
      this.enqueueTask(task);
    }
  }, {
    key: 'updateRoomState',
    value: function updateRoomState(data) {
      if (this.roomStateListener) {
        this.roomStateListener(data);
      }
    }
  }, {
    key: 'getRoomState',
    value: function getRoomState(cb) {
      var room = new _message.Room(this.roomId);
      var msg = new _message.Message(_constant2.default.MSG_ROOM_GET_STATE, 0, this.version, room);

      this.enqueueTask(new _task.Task(msg, function (msg, err) {
        if (typeof err !== 'undefined') {
          if (typeof cb === 'function') {
            cb(undefined, err);
          }
          return;
        }

        if (msg.Cmd === _constant2.default.MSG_ROOM_STATE) {
          var roomId = msg.Body.RoomId;
          var state = msg.Body.State;

          var m = JSON.parse(state);
          if (typeof cb === 'function') {
            cb(m, undefined);
          }
          return;
        }

        if (msg.Cmd === _constant2.default.MSG_RESULT) {
          if (typeof cb === 'function') {
            cb(undefined, new _task.Error(msg.Body.Code, msg.Body.Msg));
          }
        }
        if (typeof cb === 'function') {
          cb(undefined, new _task.Error(SDK_CODE.interval_err, "cmd err"));
        }
      }));
    }
  }, {
    key: 'execTask',
    value: function execTask(task) {
      if (typeof task == 'undefined') {
        return;
      }
      var msg = task.msg;
      this.sendMsg(msg);
    }
  }, {
    key: 'handleMsg',
    value: function handleMsg(msg) {
      logger('handleMsg', msg);
      this.task_queue.handleMsg(msg);
    }
  }, {
    key: 'defaultHandler',
    value: function defaultHandler(msg) {
      switch (msg.Cmd) {

        case _constant2.default.MSG_ACK:
          this.handleAck(msg);
          break;

        case _constant2.default.MSG_AUTH_STATUS:
          // this.handleAuthStatus(msg)
          break;

        case _constant2.default.MSG_SYSTEM:
          this.handleSystemMessage(msg);
          break;

        case _constant2.default.MSG_IM:
          this.handleIM(msg);
          break;
        case _constant2.default.MSG_SYNC_NOTIFY:
          this.handleSyncNotify(msg);
          break;
        case _constant2.default.MSG_SYNC_BEGIN:
          this.handleSyncBegin(msg);
          break;
        case _constant2.default.MSG_SYNC_END:
          this.handleSyncEnd(msg);
          break;

        case _constant2.default.MSG_ROOM_IM:
          this.handleRoomIM(msg);
          break;
        case _constant2.default.MSG_GROUP_IM:
          this.handleGroupIM(msg);
          break;
        case _constant2.default.MSG_SYNC_GROUP_NOTIFY:
          this.handleSyncGroupNotify(msg);
          break;
        case _constant2.default.MSG_SYNC_GROUP_BEGIN:
          this.handleSyncGroupBegin(msg);
          break;
        case _constant2.default.MSG_SYNC_GROUP_END:
          this.handleSyncGroupEnd(msg);
          break;
        case _constant2.default.MSG_TRANSMISSION:
          this.handleTransmission(msg);
          break;
        case _constant2.default.MSG_ROOM_NOTIFY:
          this.handleRoomStateNotify(msg);
          break;

      }
    }
  }, {
    key: 'handleAck',
    value: function handleAck(msg) {
      // logger(`>>> ack: seq = ${msg.Body.Seq}`)
    }
  }, {
    key: 'handleSystemMessage',
    value: function handleSystemMessage(msg) {
      logger('>>> \u7CFB\u7EDF\u6D88\u606F: ' + msg.Body.Content + ' ');
      // if (this.sysListener) {
      //   this.sysListener(msg.Cmd,msg.Body)
      // }
      switch (msg.Body.SystemMsgId) {
        case _constant2.default.SYS_ANOTHER:
          this.requireReconnect = false;
          if (this.anotherLoginListener) {
            this.anotherLoginListener();
          }
          break;
        case _constant2.default.SYS_ROOM_ENTER:
          var enter_content = JSON.parse(msg.Body.Content);
          if (this.roomMemberJoinListener) {
            this.roomMemberJoinListener(enter_content);
          }
          break;
        case _constant2.default.SYS_ROOM_LEAVE:
          var leave_content = JSON.parse(msg.Body.Content);
          if (this.roomMemberLeftListener) {
            this.roomMemberLeftListener(leave_content);
          }
          break;
        case _constant2.default.SYS_CUSTOM:
          if (this.customSysListener) {
            this.customSysListener(msg.Body.Content);
          }
        default:

          break;
      }
    }
  }, {
    key: 'handleIM',
    value: function handleIM(msg) {
      logger('>>> [' + new Date(msg.Body.Timestamp) + '] ' + msg.Body.FromUsername + ': ' + msg.Body.Content);
      if (this.peerListener) {
        this.peerListener(msg.Body);
      }
    }
  }, {
    key: 'handleSyncNotify',
    value: function handleSyncNotify(msg) {
      var newSyncKey = msg.Body.SyncKey;

      var now = new Date().getTime();

      var isSyncing = this.sync.isSyncing && now - this.sync.syncTimestamp < 4000;

      if (!isSyncing && newSyncKey > this.sync.sync_key) {
        this.sendSync(this.sync.sync_key);
        this.sync.isSyncing = true;
        this.sync.syncTimestamp = now;
      } else if (newSyncKey > this.sync.pending_key) {
        this.sync.pending_key = newSyncKey;
      }
    }
  }, {
    key: 'handleSyncBegin',
    value: function handleSyncBegin(msg) {}
  }, {
    key: 'handleSyncEnd',
    value: function handleSyncEnd(msg) {
      var newSyncKey = msg.Body.SyncKey;
      if (newSyncKey > this.sync.sync_key) {
        this.sync.sync_key = newSyncKey;
        this.sendSyncKey(this.sync.sync_key);
      }

      var now = new Date().getTime();
      this.sync.isSyncing = false;

      if (this.sync.pending_key > this.sync.sync_key) {
        this.sendSync(this.sync.sync_key);
        this.sync.isSyncing = true;
        this.sync.syncTimestamp = now;
        this.sync.pending_key = 0;
      }
    }
  }, {
    key: 'handleRoomIM',
    value: function handleRoomIM(msg) {
      logger('>>> [' + new Date(msg.Body.Timestamp) + '] [\u804A\u5929\u5BA4-' + msg.Body.Receiver + ']' + msg.Body.FromUsername + ': ' + msg.Body.Content);
      if (this.roomListener) {
        this.roomListener(msg.Body);
      }
    }
  }, {
    key: 'handleGroupIM',
    value: function handleGroupIM(msg) {
      logger('>>> [' + new Date(msg.Body.Timestamp) + '] [\u7FA4-' + msg.Body.Receiver + ']' + msg.Body.FromUsername + ': ' + msg.Body.Content);
      if (this.groupListener) {
        this.groupListener(msg.Body);
      }
    }
  }, {
    key: 'handleSyncGroupNotify',
    value: function handleSyncGroupNotify(msg) {
      var newSyncKey = msg.Body.SyncKey;
      var group_id = msg.Body.GroupId;
      logger('handleSyncGroupNotify');
      var sync = new Sync();
      if (typeof this.groupSyncKeys[group_id] !== 'undefined') {
        sync = this.groupSyncKeys[group_id];
      } else {
        sync = new Sync();
        this.groupSyncKeys[group_id] = sync;
      }

      var now = new Date().getTime();

      var isSyncing = sync.isSyncing && now - sync.syncTimestamp < 4000;

      if (!isSyncing && newSyncKey > sync.sync_key) {
        logger('handleSyncGroupNotify1');
        this.sendGroupSync(sync.sync_key, group_id);
        sync.isSyncing = true;
        sync.syncTimestamp = now;
      } else if (newSyncKey > sync.pending_key) {
        logger('handleSyncGroupNotify2');
        sync.pending_key = newSyncKey;
      }
    }
  }, {
    key: 'handleSyncGroupBegin',
    value: function handleSyncGroupBegin(msg) {}
  }, {
    key: 'handleSyncGroupEnd',
    value: function handleSyncGroupEnd(msg) {
      var newSyncKey = msg.Body.SyncKey;
      var group_id = msg.Body.GroupId;

      var sync = new Sync();
      if (typeof this.groupSyncKeys[group_id] !== 'undefined') {
        sync = this.groupSyncKeys[group_id];
      } else {
        logger('no group : ' + group_id);
        return;
      }

      if (newSyncKey > sync.sync_key) {
        sync.sync_key = newSyncKey;
        this.groupSyncKeys[group_id] = sync;
        this.sendGroupSyncKey(sync.sync_key, group_id);
      }

      var now = new Date().getTime();
      sync.isSyncing = false;

      if (sync.pending_key > sync.sync_key) {
        this.sendGroupSync(sync.sync_key, group_id);
        sync.isSyncing = true;
        sync.syncTimestamp = now;
        sync.pending_key = 0;
      }
    }
  }, {
    key: 'handleTransmission',
    value: function handleTransmission(msg) {
      logger("handleTransmission", msg);
      if (this.transListener) {
        this.transListener(msg.Body);
      }
    }
  }, {
    key: 'handleRoomStateNotify',
    value: function handleRoomStateNotify(msg) {
      logger('handleRoomStateNotify, room state update', msg);
      var self = this;
      if (self.roomStateListener) {
        self.getRoomState(function (data, err) {
          if (typeof err === 'undefined') {
            self.updateRoomState(data);
          }
        });
      }
    }
  }, {
    key: 'syncGroup',
    value: function syncGroup() {

      var self = this;

      var auth_api = self.api_host + '/auth';
      var group_api = self.api_host + '/api/group/loadGroup';

      var expire = parseInt(new Date().getTime() / 1000).toString();

      var params1 = {
        appkey: this.appkey,
        expire: expire
      };
      var sign = (0, _util.keySign)(params1, this.appsecret);
      params1.sign = sign;

      _network2.default.post(auth_api, params1, function (err, res) {
        if (err === null) {
          if (res.ret === 1) {
            var token = res.data.token;

            logger('token=', token);
            _network2.default.post(group_api, {
              page: 1,
              page_limit: 10000,
              username: self.username,
              token: token
            }, function (err2, res2) {
              if (err2 === null && res2.ret === 1) {
                var groups = res2.data.groups;
                self.groups = groups;
                logger('groups=', groups);
                for (var i = 0; i < groups.length; i++) {
                  var group_id = groups[i].id;
                  self.groupSyncKeys[group_id] = new Sync();
                  self.sendGroupSync(0, group_id);
                }
              }
            });
          }
        }
      });
    }
  }, {
    key: 'sendSync',
    value: function sendSync(sync_key) {

      var sync_key_msg = new _message.SyncKeyMessage(sync_key);
      var msg = new _message.Message(_constant2.default.MSG_SYNC, this.seq, this.version, sync_key_msg);

      this.sendMsg(msg);
    }
  }, {
    key: 'sendGroupSync',
    value: function sendGroupSync(sync_key, group_id) {
      var group_sync_key_msg = new _message.GroupSyncKeyMessage(sync_key, group_id);
      var msg = new _message.Message(_constant2.default.MSG_SYNC_GROUP, this.seq, this.version, group_sync_key_msg);
      this.sendMsg(msg);
    }
  }, {
    key: 'sendMsg',
    value: function sendMsg(msg) {
      var buffer = (0, _protocol.toData)(msg);
      var self = this;
      setTimeout(function () {
        self.socket.send(buffer);
      }, MSG_SEND_INTERVAL);
    }
  }, {
    key: 'sendSyncKey',
    value: function sendSyncKey(sync_key) {
      var sync_key_msg = new _message.SyncKeyMessage(sync_key);
      var msg = new _message.Message(_constant2.default.MSG_SYNC_KEY, this.seq, this.version, sync_key_msg);
      this.sendMsg(msg);
    }
  }, {
    key: 'sendGroupSyncKey',
    value: function sendGroupSyncKey(sync_key, group_id) {
      var group_sync_key_msg = new _message.GroupSyncKeyMessage(sync_key, group_id);
      var msg = new _message.Message(_constant2.default.MSG_GROUP_SYNC_KEY, this.seq, this.version, group_sync_key_msg);
      this.sendMsg(msg);
    }
  }]);

  return IMService;
}();

exports.default = IMService;
//# sourceMappingURL=IMService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ciim_sdk@3.0.8@ciim_sdk/dist/im/IMService.js
// module id = lcq1
// module chunks = 0